import { Button } from "@carbon/react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./notfound.module.scss";
import React from "react";

function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>{t("x_twiik_coach", { item: t("404 Not Found") })}</title>
      </Helmet>

      <div className={"tc-card " + styles.box}>
        <h1>{t("page_not_found")}</h1>
        <p>{t("the_page_you_are_looking_for_c")}</p>
        <Button
          kind="secondary"
          onClick={() => navigate("/", { replace: true })}
        >
          {t("go_to_homepage")}
        </Button>
      </div>
    </>
  );
}

export default React.memo(NotFound);
